export default {
	text: "Browse all templates",
};
